import { ChartValue } from "./ChartValue";

const BAR_WIDTH = 0.7;

export class WaterfallChart {

    public create(values: ChartValue[], showValues: boolean = false): SVGSVGElement {
        let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        //svg.setAttribute("preserveAspectRatio", "none");
        svg.setAttribute("viewBox", "0 0 42 42");
        svg.classList.add("a-svg");
        svg.classList.add("a-svg-bar");

        if (values && values.length > 0) {
            // get total value
            let total = 0;
            for (let value of values) {
                total += value.value;
            }

            if (total > 0) {
                // factor and width per bar
                let factor = 40 / total;
                let width = 40 / (values.length + 1);
                let x = 0;
                let y = 41;
                for (let value of values) {
                    if (value.value > 0) {
                        let height = value.value * factor;
                        y -= height;
                        svg.appendChild(this.createBar(x, y, value.className, height, width));
                        if (showValues) {
                            svg.appendChild(this.createText(x, y, value.value * factor, width, value.value));
                        }
                    }
                    x += width;
                }
                svg.appendChild(this.createBar(x, 1, "a-chart-grey", 40, width));
                if (showValues) {
                    svg.appendChild(this.createText(x, 1, 40, width, total));
                }
            }
        }

        return svg;

    }

    createBar(x: number, y: number, className: string, height: number, width: number): SVGRectElement {
        let space = (width - (width * BAR_WIDTH)) / 2;
        width = width * BAR_WIDTH;

        let rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        rect.classList.add(className);
        rect.setAttribute("x", (x + space).toString());
        rect.setAttribute("y", y.toString());
        rect.setAttribute("width", width.toString());
        rect.setAttribute("height", height.toString());
        return rect;
    }

    createText(x: number, y: number, height: number, width: number, value: number): SVGTextElement {
        let text = document.createElementNS("http://www.w3.org/2000/svg", "text");
        text.setAttribute("text-anchor", "middle");
        text.classList.add("svg-bar-text");

        let tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
        tspan.setAttribute("x", (x + width / 2).toString());
        tspan.setAttribute("y", (y + height / 2).toString());
        tspan.setAttribute("alignment-baseline", "middle");
        tspan.innerHTML = value.toString();
        text.appendChild(tspan);

        return text;
    }
}